import { GO_TO_MENU_ROUTE_AND_OPEN } from '@piconetworks/menu-middleware'

import Internal from 'common/modules/internal'
import Router from 'common/modules/router'

const xFrame = {
    launcher: {
        openPromptAndHeader: ({ dispatch, entryRoute }) => {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_prompt',
                    ...Router.creators.replace({
                        ...(
                            typeof entryRoute === 'string'
                                ? {
                                    payload: {
                                        url: entryRoute,
                                    },
                                }
                                : {
                                    payload: entryRoute,
                                }
                        ),
                    }),
                },
            }))

            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_header',
                    ...Router.creators.replace({
                        payload: {
                            url: {
                                pathname: '/header-bar',
                                ...(entryRoute === '/registration' && {
                                    query: {
                                        useDefault: true,
                                    },
                                }),
                            },
                        },
                    }),
                },
            }))

            dispatch(Internal.creators.showPrompt())
            dispatch(Internal.creators.showHeader())
            dispatch(Internal.creators.destroyLauncher())
            dispatch(Internal.creators.destroyMenu())
        },
        toggleMenu: ({ dispatch, showMenu }) => {
            if (!showMenu) {
                dispatch(Router.creators.replace({
                    payload: {
                        url: '/launcher/icon',
                    },
                }))

                dispatch(Internal.creators.destroyMenu())
            } else {
                dispatch(Internal.creators.sendMessage({
                    payload: {
                        target: 'pico_menu',
                        ...Router.creators.replace({
                            payload: {
                                url: '/popup-menu',
                            },
                        }),
                    },
                }))

                dispatch(Internal.creators.sendMessage({
                    payload: {
                        target: 'pico_menu',
                        ...({
                            type: GO_TO_MENU_ROUTE_AND_OPEN,
                            payload: {
                                menuRoute: '/',
                                backRoute: '/',
                            },
                        }),
                    },
                }))

                dispatch(Internal.creators.showMenu())

                dispatch(Router.creators.replace({
                    payload: {
                        url: '/launcher/x',
                    },
                }))
            }
        },
    },
    header: {
        goToPromptLogin: ({ dispatch }) => {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_prompt',
                    ...Router.creators.replace({
                        payload: {
                            url: '/login',
                        },
                    }),
                },
            }))
        },
    },
    prompt: {
        showMenu: ({ dispatch }) => {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_menu',
                    ...Router.creators.replace({
                        payload: {
                            url: '/popup-menu',
                        },
                    }),
                },
            }))

            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_launcher',
                    ...Router.creators.replace({
                        payload: {
                            url: '/launcher/x',
                        },
                    }),
                },
            }))

            dispatch(Internal.creators.destroyPrompt())
            dispatch(Internal.creators.destroyHeader())
            dispatch(Internal.creators.showLauncher())
            dispatch(Internal.creators.showMenu())
        },
        showLauncher: ({ dispatch }) => {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_launcher',
                    ...Router.creators.replace({
                        payload: {
                            url: '/launcher/icon',
                        },
                    }),
                },
            }))
            dispatch(Internal.creators.destroyMenu())

            dispatch(Internal.creators.destroyPrompt())
            dispatch(Internal.creators.destroyHeader())
            dispatch(Internal.creators.showLauncher())
        },
        showThankYou: ({ dispatch, thankYouText }) => {
            xFrame.prompt.showMenu({ dispatch })

            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_menu',
                    ...({
                        type: GO_TO_MENU_ROUTE_AND_OPEN,
                        payload: {
                            menuRoute: '/notification',
                            text: thankYouText,
                            backRoute: '/',
                        },
                    }),
                },
            }))
        },
        showPaswordUpdated: ({ dispatch, firstTimePassword }) => {
            xFrame.prompt.showMenu({ dispatch })

            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_menu',
                    ...({
                        type: GO_TO_MENU_ROUTE_AND_OPEN,
                        payload: {
                            menuRoute: '/notification',
                            text: `Your password has been successfully ${firstTimePassword ? 'created' : 'updated'}.`,
                            backRoute: '/',
                        },
                    }),
                },
            }))
        },
        showMenuRoute: ({
            dispatch,
            menuRoute = '/notification',
            data,
        }) => {
            xFrame.prompt.showMenu({ dispatch })

            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_menu',
                    ...({
                        type: GO_TO_MENU_ROUTE_AND_OPEN,
                        payload: {
                            menuRoute,
                            backRoute: '/',
                            data,
                        },
                    }),
                },
            }))
        },
        showHeaderRoute: ({
            dispatch,
            payload = {
                url: {
                    pathname: '/header-bar',
                },
            },
        }) => {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_header',
                    ...Router.creators.replace({
                        payload,
                    }),
                },
            }))
        },
    },
    menu: {
        convertGift: ({ dispatch }) => {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_prompt',
                    ...Router.creators.replace({
                        payload: {
                            url: '/convert-gift',
                        },
                    }),
                },
            }))
            dispatch(Router.creators.replace({
                payload: {
                    url: '/button/icon',
                },
            }))

            dispatch(Internal.creators.destroyMenu())
            dispatch(Internal.creators.showPrompt())
        },
        logout: ({ dispatch }) => {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_launcher',
                    ...Router.creators.replace({
                        payload: {
                            url: '/launcher/icon',
                        },
                    }),
                },
            }))
            dispatch(Internal.creators.logout())
            dispatch(Internal.creators.destroyPrompt())
            dispatch(Internal.creators.destroyHeader())
            dispatch(Internal.creators.destroyMenu())
            dispatch(Internal.creators.showLauncher())
            xFrame.launcher.toggleMenu({ dispatch, showMenu: false })
        },
    },
    appError: {
        close: ({ dispatch }) => {
            dispatch(Internal.creators.destroyAppError())
        },
    },
}

export default xFrame
